<template>
<SidebarComponent /> <!-- Aggiungi il componente sidebar qui -->
  <div class="dashboard-layout">
      <div class="content-container"> <!-- Contenitore per il contenuto principale -->
  <div class="card-container">

    <div class="titolo-card">
      <h1>Qui potrai controllare le prenotazioni</h1>
    </div>
    <!-- Immagine centrata -->
    <div class="card-image">
  <img src="https://www.metodofusco.it/media/image_desktop_studi.jpg" alt="Descrizione dell'immagine">
    </div>


  <!--
    <div class="card-header2" @click="goToCoachingday">
  <div class="icon-column">
    <span class="material-icons">confirmation_number</span>
  </div>
  
  <div class="text-column">
    <div class="header-text">Coaching day</div>
    <div class="text-card">Controlla le prenotazioni dei coaching day</div>
  </div>
  
  <div class="icon-column-right">
      <span class="material-icons">chevron_right</span>
  </div>
</div>
-->


<div class="card-header2" @click="goToVideocall">
  <!-- Colonna 1: solo icona -->
  <div class="icon-column">
    <span class="material-icons">video_call</span>
  </div>
  
  <!-- Colonna 2: Titolo e Descrizione -->
  <div class="text-column">
    <div class="header-text">Video call</div>
    <div class="text-card">Visualizza tutte le video call con il team nutrizionale</div>
  </div>
  
  <!-- Colonna 3: icona attaccata al bordo destro -->
  <div class="icon-column-right">
      <span class="material-icons">chevron_right</span>
  </div>
</div>



<div class="card-header2" @click="goToPrivacy">
  <!-- Colonna 1: solo icona -->
  <div class="icon-column">
    <span class="material-icons">lock_open</span>
  </div>
  
  <!-- Colonna 2: Titolo e Descrizione -->
  <div class="text-column">
    <div class="header-text">Privacy Accettate</div>
    <div class="text-card">Visualizza tutti gli utenti che hanno accettato la privacy</div>
  </div>
  
  <!-- Colonna 3: icona attaccata al bordo destro -->
  <div class="icon-column-right">
      <span class="material-icons">chevron_right</span>
  </div>
</div>



<div class="card-header2" @click="goToContattiList">
  <!-- Colonna 1: solo icona -->
  <div class="icon-column">
    <span class="material-icons">event</span>
  </div>
  
  <!-- Colonna 2: Titolo e Descrizione -->
  <div class="text-column">
    <div class="header-text">Contatti Nuovi</div>
    <div class="text-card">Visualizza tutte le video call con il team nutrizionale</div>
  </div>
  
  <!-- Colonna 3: icona attaccata al bordo destro -->
  <div class="icon-column-right">
      <span class="material-icons">chevron_right</span>
  </div>
</div>


<div class="card-header2" @click="goToRiContattiList">
  <!-- Colonna 1: solo icona -->
  <div class="icon-column">
    <span class="material-icons">event</span>
  </div>
  
  <!-- Colonna 2: Titolo e Descrizione -->
  <div class="text-column">
    <div class="header-text">Ricontatti</div>
    <div class="text-card">Visualizza tutti i contatti da richiamare.</div>
  </div>
  
  <!-- Colonna 3: icona attaccata al bordo destro -->
  <div class="icon-column-right">
      <span class="material-icons">chevron_right</span>
  </div>
</div>


<div class="card-header2" @click="goToCampagnaIntegrazione">
  <!-- Colonna 1: solo icona -->
  <div class="icon-column">
    <span class="material-icons">event</span>
  </div>
  
  <!-- Colonna 2: Titolo e Descrizione -->
  <div class="text-column">
    <div class="header-text">Campagna FC6</div>
    <div class="text-card">Visualizza tutti i contatti inerenti la campagna</div>
  </div>
  
  <!-- Colonna 3: icona attaccata al bordo destro -->
  <div class="icon-column-right">
      <span class="material-icons">chevron_right</span>
  </div>
</div>


<div class="card-header2" @click="goToCampagnaIntegrazioneFc3">
  <!-- Colonna 1: solo icona -->
  <div class="icon-column">
    <span class="material-icons">event</span>
  </div>
  
  <!-- Colonna 2: Titolo e Descrizione -->
  <div class="text-column">
    <div class="header-text">Campagna 28 Maggio - FC3</div>
    <div class="text-card">Visualizza tutti i contatti inerenti la campagna</div>
  </div>
  
  <!-- Colonna 3: icona attaccata al bordo destro -->
  <div class="icon-column-right">
      <span class="material-icons">chevron_right</span>
  </div>
</div>


</div>
  </div>
</div>
</template>

<script>

// Importa le librerie necessarie
import { useRouter } from 'vue-router';  // Importa useRouter
import { ref } from 'vue';
import { getAuth, signOut } from 'firebase/auth'; // Importa le funzioni di autenticazione di Firebase

import SidebarComponent from '../SidebarComponent.vue'; // Importa SidebarComponent


export default {

  components: {
    SidebarComponent // Registra il componente SidebarComponent
  },
  
  setup() {
    const userTickets = ref([]);

    const router = useRouter();  // Ottieni l'istanza del router


    const goBack = () => {
      router.go(-1); // Naviga alla pagina precedente
    };

    const viewAlimentazione = async () => {
      // Il tuo codice esistente per viewAlimentazione
      // ...
    };

    const goToCoachingday = () => {
      router.push('/booking-list');  // Usa l'istanza del router
    };

    const goToVideocall = () => {
      router.push('/videocall-list-booking');  // Usa l'istanza del router
    };

    const goToPrivacy = () => {
      router.push('/privacy-accepted');  // Usa l'istanza del router
    };

    


    const goToContattiList = () => {
      router.push('/contatti-list');  // Usa l'istanza del router
    };

    const goToRiContattiList = () => {
      router.push('/ricontatti-utenti');  // Usa l'istanza del router
    };


    




    const goToCampagnaIntegrazione = () => {
      router.push('/campagna-integrazione');  // Usa l'istanza del router
    };


    const goToCampagnaIntegrazioneFc3 = () => {
      router.push('/campagna-integrazione-fc3');  // Usa l'istanza del router
    };


    const goToRicette = () => {
      router.push('/ricetta'); // Indirizza al componente RicetteComponent.vue
    };

    const goToCreateOrder = () => {
      router.push('/create-order'); // Indirizza al componente RicetteComponent.vue
    };

    const viewConversation = (ticketId) => {
      router.push({ name: 'UserTicketConversation', params: { ticketId } });
    };

    const handleLogout = async () => {
      const auth = getAuth();
      try {
        await signOut(auth);
        router.push('/');
      } catch (error) {
        console.error("Errore durante il logout:", error);
      }
    };




    return {
      userTickets,
      viewConversation,
      goToRicette,
      viewAlimentazione,
      handleLogout,  // Aggiungi questa funzione all'output
      goToCreateOrder,
      goBack,
      goToCoachingday,
      goToVideocall,
      goToContattiList,
      goToCampagnaIntegrazione,
      goToCampagnaIntegrazioneFc3,
      goToRiContattiList,
      goToPrivacy
    };
  },
};


</script>

  
<style scoped>


</style>

